import {
  SET_ERROR,
  SET_ERROR_MESSAGE,
  SET_USER_NAME,
  SET_ACCESS_TOKEN,
  SET_ACCESS,
  SET_REFRESH,
  SET_USER_DETAILS,
  SET_USER_DETAILS_ERROR,
  LOGOUT,
} from "./constants";
import { toast } from "react-toastify";

/**
 * Dispatched when loading the repositories fails
 *
 * @param  {string} error The error
 *
 * @return {object}       An action object with a type of LOAD_REPOS_ERROR passing the error
 */
export function setError(error) {
  return {
    type: SET_ERROR,
    error,
  };
}

export function setRefresh(refresh) {
  return {
    type: SET_REFRESH,
    refresh,
  };
}
/**
 * Dispatched when loading the repositories fails
 *
 * @param  {string} error The error
 *
 * @return {object}       An action object with a type of LOAD_REPOS_ERROR passing the error
 */
export function setErrorMessage(error) {
  return {
    type: SET_ERROR_MESSAGE,
    error,
  };
}
/**
 * Dispatched when loading the repositories fails
 *
 * @param  {object} userDetails The error
 *
 * @return {object}       An action object with a type of LOAD_REPOS_ERROR passing the error
 */
export function setUserDetails(userDetails) {
  return {
    type: SET_USER_DETAILS,
    userDetails,
  };
}

/**
 * Dispatched when loading the repositories fails
 *
 * @param  {string} message The error
 *
 * @return {object}       An action object with a type of LOAD_REPOS_ERROR passing the error
 */
export function setUserDetailsError(message) {
  return {
    type: SET_USER_DETAILS_ERROR,
    message,
  };
}

/**
 * Dispatched when loading the repositories fails
 *
 * @param  {string} token The error
 *
 * @return {object}       An action object with a type of LOAD_REPOS_ERROR passing the error
 */
export function setAccessToken(token) {
  return { type: SET_ACCESS_TOKEN, token };
}

export function setAccess(data) {
  return { type: SET_ACCESS, data };
}

/**
 * Dispatched when loading the repositories fails
 *
 * @param  {string} username The error
 *
 * @return {object}       An action object with a type of LOAD_REPOS_ERROR passing the error
 */
export function setUserName(username) {
  return { type: SET_USER_NAME, username };
}



/**
 * Dispatched when loading the repositories fails
 *
 * 
 *
 * @return {object}       An action object with a type of LOAD_REPOS_ERROR passing the error
 */
 export function setLogout() {
  localStorage.removeItem('authToken');
  return { type: LOGOUT };
}

export function sessionLogout(){
  localStorage.removeItem('authToken');
  toast.error("Your session has expired. Please log in again.", {
    position: "top-center",
  });
  return { type: LOGOUT };
}

